import { Bookings } from '@/types/types'
import getDurationForPax from '@/utils/getDurationForPax'

const getMaxDurationForPaxFromOfferSet = (offerSet: (Bookings.Offer | undefined)[], pax: number) => {
  return offerSet.reduce((max, offer) => {
    if (!offer || !offer.has_duration || !offer.turn_times) return max
    const duration = getDurationForPax(pax, offer.turn_times)
    return Math.max(max, duration)
  }, 0)
}

export default getMaxDurationForPaxFromOfferSet
